import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

// Base
import Button from '../../../../../base/button';
import Modal from '../../../../../base/modal';
import Wysiwyg from '../../../../../base/wysiwyg';

// Form
import Select from '../../../../../form/select';

export default class Popup extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSetMessage: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  state = {
    message: '',
    selected: {},
  }

  get showWysiwyg() {
    const { selected } = this.state;
    return selected.value === 'enterprise';
  }

  get options() {
    return [
      { value: 'personal', label: '1 User' },
      { value: 'grow', label: '2 - 5 Users' },
      { value: 'scale', label: '6-10 Users' },
      { value: 'enterprise', label: '11+ Users' },
    ]
  }

  handleSelect = (selected) => {
    const { onSelect } = this.props;
    this.setState({
      selected
    }, () => onSelect(selected.value));
  }

  handleChange = (message) => {
    const { onSetMessage } = this.props;
    this.setState({
      message
    }, () => onSetMessage(message));
  }

  handleCancel = () => {
    const { onCancel } = this.props;
    this.setState({
      message: ''
    }, () => onCancel());
  }

  render() {
    const { isOpen, onConfirm, onCancel } = this.props;
    const { message } = this.state;

    return (
      <Modal {...{
        isOpen,
        onCancel,
        onClose: onCancel,
        className: 'promo pop',
        showX: false,
      }}>
        <div className='absolute top-24 right-24'>
          <Button {...{
            size: 'custom',
            onClick: onCancel,
          }}>
            <X {...{ size: 24 }} />
          </Button>
        </div>
        <div className='padding-left-25 margin-top-24 heading-section margin-bottom-30'>
          <div className='xlg-font line-height-26 heading margin-bottom-15'>Select how many users will join the free trial plan</div>
          <div className='sm-font sub-heading line-height-24 margin-bottom-24'>Feel free to choose the number of users for your free trial—you're in control</div>
        </div>
        <div className='width-600 margin-left-25'>
          <Select {...{
            label: 'Requested Number of Users',
            options: this.options,
            placeholder: 'Please select',
            required: true,
            onSelect: this.handleSelect,
          }} />
        </div>
        {
          this.showWysiwyg &&
          <div className='margin-left-25 inline-block'>
            <Wysiwyg {...{
              onChange: this.handleChange,
              value: message,
              className: 'min-height-130 height-130 overflow-auto',
            }} />
          </div>
        }
        <div className='absolute bottom-24 right-24 flex'>
          <Button {...{
            text: 'Cancel',
            onClick: this.handleCancel,
            size: 'custom',
            className: 'cancel',
          }} />
          <Button {...{
            text: 'Confirm',
            block: true,
            className: 'submit',
            onClick: onConfirm,
          }} />
        </div>
      </Modal>
    )
  }
}